export default class UserProfile {
  constructor(data) {
    this.id = data.id;
    this.firstname = data.firstname;
    this.lastname = data.lastname;
    this.role = data.role;
    this.email = data.email;
    this.shopId = data.shopId;
    this.status = data.status;
  }

  get displayName() {
    return `${this.firstname} ${this.lastname}`;
  }
}
